import * as VhfLang from "../VhfLang";
import { useNavigate, useLocation } from "react-router-dom";
import { Form,Button } from "react-bootstrap";
import { useEffect,useState } from "react";

const Thanks = () => {

    const navigate = useNavigate();
    const {state} = useLocation();

    const [email,setEmail]=useState("Ingen epost angiven!");
   
    

    /*useEffect(() => {

    var privateJson=JSON.parse(sessionStorage.getItem(VhfLang.KeyForSessionForPrivateContact));
    if(privateJson!=null){
        setEmail(privateJson[VhfLang.EmailId]);
    }

    
    var companyJson=JSON.parse(sessionStorage.getItem(VhfLang.KeyForSessionForCompanyContact));
    if(companyJson!=null){
        setEmail(companyJson[VhfLang.EmailId]);
    }
            
      }, []);*/
useEffect(() => {
      if(state!=null||state.email!=null){
        setEmail(state.email);
      }
    }, [state.email])
      
      let emailresult=<p>En bekräftelse har skickats till: {email}</p>
      if(state.emailResponse!=null){
        emailresult= <p className="alert alert-danger">{state.emailResponse}</p>
      }


      

      const clearSession=()=>{
        sessionStorage.clear(VhfLang.KeyForSessionForPrivateContact);
        sessionStorage.clear(VhfLang.KeyForSessionForCompanyContact);
        sessionStorage.clear(VhfLang.KeyForSessionForShipInfo);
        sessionStorage.clear(VhfLang.ShipClassId);
      }


    const onSubmit = () => {
        
      clearSession();
        
        navigate(VhfLang.NavStartPage, {
        });
      };

      state.dayBookNo && clearSession();

return(
    <>
    <fieldset>
        <legend>Din ansökan om tillstånd för VHF är mottagen</legend>
        <p>
        Ditt ärende har fått diarienummer: {state.dayBookNo}
        </p>
       
        {emailresult}
        <p>
        Har du frågor angående ansökan, kontakta PTS på mobil-radio@pts.se eller 08-678 55 00.
        </p>
        <Form>
        <Button variant="forward"  onClick={onSubmit} className="buttonPaddingSecondButton" >
              {VhfLang.ButtonNewCase}
          </Button>
          </Form>
    </fieldset>


   
    </>

)
}

export default Thanks